import { Platform } from '../core/Platform';
import { merge } from 'lodash';

const definitions = {
	default: {
		/**
		 * NEW WUNDERBRICKS STYLING
		 */
		$linkColor: '$colorBrandQuaternary',
		$linkFontSize: '1.6rem',
		$titleColor: '#000000',
		$subTitleColor: '#737373',
		$textColor: '#000000',

		$colorBackground: '#FFFFFF',
		$colorBackgroundSecondary: '#E5E5E5',
		$colorDisabled: '#CCCCCC',

		$colorBrandPrimary: '#5996D5',
		$colorBrandSecondary: '#EB5D2C',
		$colorBrandTertiary: '#EAB365',
		$colorBrandQuaternary: '#589792',

		$buttonBackgroundColor: '$colorBrandQuaternary',
		$buttonBackgroundColor__Disabled: '$colorDisabled',
		$buttonBorderRadius: 12,
		$buttonTextColor: '#FFFFFF',

		$inputBorderColor: '#E9E9E9',
		$inputBorderColor__Focused: '$colorBrandQuaternary',
		$inputBorderWidth: 1,
		$inputBorderRadius: 4,
		$inputChevronColor: '#C7C7C7',
		$inputErrorColor: '#FF0000',
		$inputLabelColor: '#777777',
		$inputLabelColor__Focused: '$colorBrandQuaternary',
		$inputLabelColor__Filled: '#AAAAAA',
		$inputLabelFontSize: '1.2rem',
		$inputPlaceholderColor: '#AAAAAA',
		$inputTextColor: '#000000',

		/**
		 * OLD GUTS STYLING
		 */
		$colorAlpha: 'rgba(255, 128, 82, 1)', // orange
		$colorBeta: 'rgba(255, 82, 82, 1)', // red
		$colorCharlie: 'rgba(0, 211, 160, 1)', // green
		$colorDelta: 'rgba(255, 102, 82, 1)', // orange+red

		$colorWhite: 'rgba(255, 255, 255, 100)',
		$colorOffWhite: 'rgba(251, 251, 253, 100)',

		$colorGreyDark: 'rgba(121, 132, 141, 100)',
		$colorGrey: 'rgba(153, 164, 172, 100)',
		$colorGreyLight: 'rgba(240, 240, 240, 100)',
		$colorBlack: 'rgba(59, 64, 68, 100)',
		$colorFullBlack: 'rgba(0, 0, 0, 100)',

		// borders
		$lightBorderWidth: 1,
		$colorBorder: 'rgba(217, 217, 221, 100)',
		$colorBorderLight: 'rgba(229, 229, 229, 100)',

		// Fonts
		$sizeRegular: 16,
	},
	ios: {
		$fontLight: 'Ubuntu-Regular',
		$fontRegular: 'Ubuntu-Regular',
		$fontMedium: 'Ubuntu-Regular',
		$fontSemiBold: 'Ubuntu-Regular',
		$fontBold: 'Ubuntu-Regular',
		$weightLight: '300',
		$weightRegular: '400',
		$weightMedium: '500',
		$weightSemiBold: '500',
		$weightBold: '700',
	},
	android: {
		$fontLight: 'Ubuntu-Light',
		$fontRegular: 'Ubuntu-Regular',
		$fontMedium: 'Ubuntu-Medium',
		$fontSemiBold: 'Ubuntu-Medium',
		$fontBold: 'Ubuntu-Bold',
		$weightLight: '400',
		$weightRegular: '400',
		$weightMedium: '400',
		$weightSemiBold: '400',
		$weightBold: '400',
	},
	web: {
		$fontLight: 'Ubuntu',
		$fontRegular: 'Ubuntu',
		$fontMedium: 'Ubuntu',
		$fontSemiBold: 'Ubuntu',
		$fontBold: 'Ubuntu',
		$weightLight: '300',
		$weightRegular: '400',
		$weightMedium: '500',
		$weightSemiBold: '500',
		$weightBold: '700',
	},
};

export const Constants = merge({}, definitions.default, definitions[Platform.OS || 'web']);
